/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferralRecipientConfig } from './ReferralRecipientConfig';
import {
    ReferralRecipientConfigFromJSON,
    ReferralRecipientConfigFromJSONTyped,
    ReferralRecipientConfigToJSON,
} from './ReferralRecipientConfig';

/**
 * 
 * @export
 * @interface CreateReferralRecipientConfig201Response
 */
export interface CreateReferralRecipientConfig201Response {
    /**
     * 
     * @type {ReferralRecipientConfig}
     * @memberof CreateReferralRecipientConfig201Response
     */
    data?: ReferralRecipientConfig;
}

/**
 * Check if a given object implements the CreateReferralRecipientConfig201Response interface.
 */
export function instanceOfCreateReferralRecipientConfig201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateReferralRecipientConfig201ResponseFromJSON(json: any): CreateReferralRecipientConfig201Response {
    return CreateReferralRecipientConfig201ResponseFromJSONTyped(json, false);
}

export function CreateReferralRecipientConfig201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralRecipientConfig201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ReferralRecipientConfigFromJSON(json['data']),
    };
}

export function CreateReferralRecipientConfig201ResponseToJSON(value?: CreateReferralRecipientConfig201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ReferralRecipientConfigToJSON(value.data),
    };
}

